import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderDetailTaxService } from '../order-detail-tax.service';
import { OrderDetailTax } from '../order-detail-tax';

@Component({
    selector: 'app-order-detail-tax',
    templateUrl: './order-detail-tax.component.html',
    styleUrls: ['./order-detail-tax.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderDetailTaxComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private orderDetailTaxService: OrderDetailTaxService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.orderDetailTax = data.orderDetailTax,
			this.statuses = orderDetailTaxService.statuses;
	}

	@Input() orderDetailTax: OrderDetailTax;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderDetailTaxId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderDetailTaxId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		'orderDetailTaxDate': [],
		'isOrderDetailTax': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole orderDetailTax object
		if (this.orderDetailTax) {
			this.orderDetailTaxId = this.orderDetailTax.orderDetailTaxId;
			this.fixDates();
			this.form1.patchValue(this.orderDetailTax);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderDetailTaxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderDetailTaxService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderDetailTax = res.data.orderDetailTax;
						this.doAdd.emit(this.orderDetailTax);
					},
					(err: any) => {
						console.log('orderDetailTax-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('orderDetailTax: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderDetailTaxService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderDetailTax = res.data.orderDetailTax;
						this.doUpdate.emit(this.orderDetailTax);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderDetailTaxService.delete(this.orderDetailTax.orderDetailTaxId)
				.subscribe(
					(res: any) => {
						console.log('orderDetailTax-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderDetailTax);
					},
					(err: any) => {
						console.log('orderDetailTax-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderDetailTaxId: [this.orderDetailTaxId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			status: [],
			orderDetailTaxDate: [],
			isOrderDetailTax: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderDetailTax.orderDetailTaxDate = moment(this.orderDetailTax.orderDetailTaxDate).toDate();
	}
}
